<template>
  <div id="app">
    <!-- <div class="main-top" v-if="!isOther">
      <div class="main-top-content">
        <img @click="toHome" class="main-top-logo" src="../static/img/logo.png" alt="">
        <div class="main-top-search" :class="{beforehot:isHot}">
          <input @focus="focusfns" @blur="blurfns" class="search-input" type="text" v-model="search" :placeholder="hotSearch">
          <div class="search-btn" @click="goSearch">
            <img src="../static/img/search.png" alt="">
            搜索
          </div>
        </div>
        <el-dropdown class="main-top-right">
          <span class="el-dropdown-link">
            <img class="right-icon" src="../static/img/user.png" alt="">
            {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item >
              <div @click="goCollection()">收藏页</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <left-list v-if="hasLeft && !isOther" class="main-left" ref="leftdata"></left-list>
    <right-block v-if="hasLRight && !isOther" class="main-right"></right-block> -->
    <router-view :datalist="dataList" :datapara="dataP" :topinfo="topInfo" />
  </div>
</template>

<script>
import leftList from "./components/left.vue";
import rightBlock from "./components/right.vue";
import service from "./service/demoService";
export default {
  name: "App",
  components: { leftList, rightBlock },
  data() {
    return {
      isOther: false, //是否是帮助中心之外的其他页面
      myCollection: [],
      topInfo: "",
      dataList: {
        total: 0,
        list: [
          // {
          //   id:'1',
          //   title:'2020年国家科学技术奖获奖名单',
          //   desc:'2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录等级获奖记录,2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录国家科技进步奖全部等级奖励。',
          //   date:'2019-12-23',
          //   type:'科学研究',
          //   source_name:'中华人民共和国科学技术部',
          //   collection:1,
          // },
          // {
          //   id:'2',
          //   title:'2020年国家科学技术奖获奖名单',
          //   desc:'2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录等级获奖记录,2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录国家科技进步奖全部等级奖励。',
          //   date:'2019-12-24',
          //   type:'科学研究',
          //   source_name:'中华人民共和国科学技术部',
          //   collection:2,
          // },
        ],
      },
      dataP: {
        pageSize: 7,
        pageNo: 1,
        isshow: 1,
      },
      userName: "",
      hasLRight: true,
      hasLeft: true,
      search: "",
      isHot: true,
      hotSearch: "",
    };
  },
  watch: {
    $route: "routerChange",
  },
  methods: {
    getMyCollection() {
      // let data = {
      //   pageSize:'',
      //   pageNo:'',
      // }
      service
        .getmycollection()
        .then((res) => {
          console.log(res);
          if (res.state == 0) {
            this.myCollection = res.data.map((item) => {
              return item.id;
            });
            console.log(this.myCollection);
          }
        })
        .catch((err) => {
          this.open("系统错误！", "warning");
        });
    },
    toHome() {
      this.dataP = {
        pageSize: 7,
        pageNo: 1,
        isshow: 1,
      };
      service
        .getsearchdata(this.dataP)
        .then((res) => {
          if (res.state == 0) {
            this.dataList = res.data;
            this.dataList.list.forEach((item) => {
              if (this.myCollection.indexOf(item.id) > -1) {
                item.collection = 1;
              } else {
                item.collection = 2;
              }
            });
            this.topInfo = "最新文档";
          }
        })
        .catch((err) => {
          this.open("系统错误！", "warning");
        });
      // this.$router.push({path:'/home'});
      this.$router.push({ path: "/fileCenter" });
    },
    open(str, type) {
      this.$message({
        message: str,
        type: type,
        duration: 800,
      });
    },
    getData() {
      service
        .getsearchdata(this.dataP)
        .then((res) => {
          if (res.state == 0) {
            this.dataList = res.data;
            this.dataList.list.forEach((item) => {
              if (this.myCollection.indexOf(item.id) > -1) {
                item.collection = 1;
              } else {
                item.collection = 2;
              }
            });
            this.topInfo = "约找到" + res.data.total + "条信息";
          }
        })
        .catch((err) => {
          this.open("系统错误！", "warning");
        });
    },
    goCollection() {
      console.log(111);
      this.$router.push({ path: "/collection" });
    },
    routerChange(val, oldval) {
      let path = this.$route.path;

      console.log(path);
      if (path == "/fileCenter") {
        this.hasLeft = true;
        this.hasLRight = true;
      } else if (path == "/detailed") {
        this.hasLeft = false;
        this.hasLRight = true;
      } else if (path == "/collection") {
        this.hasLeft = false;
        this.hasLRight = false;
      } else if (path == "/relevant") {
        this.hasLeft = false;
        this.hasLRight = true;
      }
      if (path == "/helpCenter") {
        this.isOther = true;
      } else {
        this.isOther = false;
      }
    },
    goSearch() {
      let path = this.$route.path;
      // if(path !== '/home'){
      //   this.$router.push({path:'/home'});
      // }
      if (path !== "/fileCenter") {
        this.$router.push({ path: "/fileCenter" });
      }
      let data = this.$refs.leftdata.searchP;
      data.keyword = this.search;
      Object.assign(this.dataP, data);
      console.log(this.dataP);
      this.getData();
    },
    focusfns() {
      this.isHot = false;
    },
    blurfns() {
      this.isHot = true;
    },
  },
  created() {
    // this.getMyCollection();
    // this.getData();
    let path = this.$route.path;
    if (path == "/fileCenter") {
      this.getMyCollection();
      this.toHome();
    }

    // this.$cookie.set('absms_crm2_userName',this.input1,{ expires: 7 });
    // this.$cookie.set('absms_crm2_password',this.input2,{ expires: 7 });
  },
  mounted() {
    this.routerChange();
  },
};
</script>

<style lang="less">
@import "../static/less/mainTop.less";
@import "../static/less/element.less";
</style>



// WEBPACK FOOTER //
// src/App.vue